import React, { useEffect, useState } from "react";
import { Share2, Trophy, Loader2, Copy } from "lucide-react";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { referrals } from "@/lib/api";
import { formatIDR } from "@/lib/format";

export default function Referral() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    referrals.leaderboard().then(setRows).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const copy = (code) => { navigator.clipboard.writeText(code); toast.success("Kode disalin"); };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-gray-900">Referral Program</h1>
        <p className="text-sm text-gray-500 mt-1">Pelanggan Anda jadi tim marketing. Setiap customer punya kode referral otomatis.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <Card className="border-emerald-200 bg-gradient-to-br from-emerald-50 to-white">
          <CardContent className="p-6">
            <div className="w-11 h-11 rounded-lg bg-emerald-600 text-white flex items-center justify-center"><Share2 /></div>
            <h3 className="mt-4 font-heading font-semibold text-gray-900">Cara Kerja Program</h3>
            <ol className="mt-2 text-sm text-gray-600 space-y-1 list-decimal list-inside">
              <li>Setiap customer otomatis punya kode referral</li>
              <li>Mereka share kode ke teman</li>
              <li>Teman order → kedua-duanya dapat cashback</li>
              <li>Track semua referral di sini</li>
            </ol>
          </CardContent>
        </Card>
        <Card className="border-gray-200"><CardContent className="p-6">
          <div className="text-xs text-gray-500 uppercase tracking-wider font-bold">Total Referrers</div>
          <div className="mt-2 font-heading text-3xl font-bold text-gray-900">{rows.length}</div>
          <div className="mt-1 text-xs text-gray-500">Pelanggan yang berhasil mengundang</div>
        </CardContent></Card>
        <Card className="border-gray-200"><CardContent className="p-6">
          <div className="text-xs text-gray-500 uppercase tracking-wider font-bold">Revenue dari Referral</div>
          <div className="mt-2 font-heading text-3xl font-bold text-emerald-600">{formatIDR(rows.reduce((s, r) => s + (r.revenue_generated || 0), 0))}</div>
          <div className="mt-1 text-xs text-gray-500">Total dari semua referral</div>
        </CardContent></Card>
      </div>

      <Card className="border-gray-200">
        <CardContent className="p-6">
          <h3 className="font-heading font-semibold text-gray-900 flex items-center gap-2"><Trophy className="text-amber-500" size={18} /> Leaderboard Referral</h3>
          {loading ? <div className="py-12 flex justify-center"><Loader2 className="animate-spin text-emerald-600" /></div>
            : rows.length === 0 ? (
              <div className="py-12 text-center text-sm text-gray-500">
                Belum ada referral. Beri tahu pelanggan tentang kode referral mereka via WhatsApp campaign!
              </div>
            ) : (
              <div className="mt-4 space-y-2">
                {rows.map((r, i) => (
                  <div key={r.customer.id} className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-50">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${i === 0 ? "bg-amber-100 text-amber-700" : i === 1 ? "bg-gray-200 text-gray-700" : i === 2 ? "bg-orange-100 text-orange-700" : "bg-emerald-50 text-emerald-700"}`}>
                      {i + 1}
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900">{r.customer.name}</div>
                      <div className="text-xs text-gray-500 flex items-center gap-2">
                        <span>Kode:</span>
                        <button onClick={() => copy(r.customer.referral_code)} className="font-mono text-emerald-600 hover:underline flex items-center gap-1" data-testid={`copy-ref-${r.customer.id}`}>
                          {r.customer.referral_code} <Copy size={10} />
                        </button>
                      </div>
                    </div>
                    <div className="text-right">
                      <Badge className="bg-emerald-50 text-emerald-700 border-emerald-200 border">{r.referrals} referral</Badge>
                      <div className="mt-1 text-sm font-semibold text-gray-900">{formatIDR(r.revenue_generated)}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
        </CardContent>
      </Card>
    </div>
  );
}
